import React, { Component } from "react";
import QRCode from "qrcode";
import { getQrCode } from "apis";
import { displayError } from "helpers";
import { Button } from "appStyles";
import styled, { css } from "react-emotion";
import GetAppIcon from "@material-ui/icons/GetApp";

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
`;

class QRCodeGenerator extends Component {
  state = {
    url: "",
  };

  componentDidMount() {
    this.downloadQrImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      this.downloadQrImage();
    }
  }

  // downloadQrImage = () => {
  //   const { text, width, logo, navBarColor } = this.props;
  //   console.log(this.props);
  //   // const { activeApp } = this.props;

  //   if (text) {
  //     return getQrCode(text, width || 200, logo, navBarColor)
  //       .then((url) => {
  //         this.setState({ url });
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //     // QRCode(text, width);
  //   } else {
  //     this.setState({ url: "" });
  //   }
  // };

  downloadQrImage = () => {
    const { text, width } = this.props;
    if (text) {
      return QRCode.toDataURL(text, {
        width: width || 200,
      })
        .then((url) => {
          this.setState({ url });
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.setState({ url: "" });
    }
  };

  render() {
    const { url } = this.state;
    const { name, marginLeft } = this.props;
    // console.dir(this.props);

    return (
      <div
        style={{
          display: "flex",
          marginLeft: marginLeft ? marginLeft : "8px",
        }}
      >
        {url ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              style={{ display: "inline-flex", width: "105px", float: "left" }}
              src={url}
              alt="qrcode"
            ></img>
            <Button
              className={mdcButton}
              style={{
                display: "inline-flex",
                alignItems: "center",
                height: "42px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
              onClick={() => {
                if (!url)
                  return displayError(
                    "The QR code is generated based off your deal password, so it can’t be empty."
                  );
              }}
            >
              <GetAppIcon style={{ marginRight: "5px" }}></GetAppIcon>
              {url ? (
                <a href={url} download={name}>
                  Download{" "}
                </a>
              ) : (
                "Download"
              )}
            </Button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default QRCodeGenerator;
